export default __webpack_public_path__ + "static/media/07-Tim-white.1a8d1967.png";